<template>
  <div class="card-dropdown">
    <div class="panel panel-default contact-card card-view">
      <div class="bg-white">
        <div class="row card-row">
          <div class="col-md-2 with-padding">
            <div class="user-img-wrap">
              <i class="circle">
                <img class="card-user-img icon" :src="`${imagePath}`">
              </i>
            </div>
          </div>
          <div class="col-md-9 decreased-padding">
            <div class>
              <div class="user-detail-wrap">
                <label :class="labelClassNames">{{ labelValue }}</label>
                <select
                  :disabled="inputDisabled"
                  v-model="selected"
                  class="form-control selection fix-height"
                  @change="inputSelected"
                >
                  <option :value="defaultValue !== undefined ? null : undefined">{{$t('app.choose')}}</option>
                  <option
                    v-for="(option,index) in list"
                    :key="index"
                    v-bind:value="option.value"
                  >{{ option.text }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="pull-right"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardInput',
  components: {},
  props: {
    list: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: [String, Number],
      required: false,
    },
    labelClassNames: {
      type: String,
      default: '',
    },
    labelValue: {
      type: String,
      default: '',
    },
    imagePath: {
      type: String,
      default: 'static/avatar.png',
    },
    inputDisabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
  created() {
    this.selected = this.defaultValue;
  },
  methods: {
    inputSelected() {
      this.$emit('input', this.selected);
    },
  },
  watch: {
    defaultValue(newVal) {
      this.selected = newVal; // Update selected when value changes
    }
  },
};
</script>

<style lang="scss" scoped>
.card-row {
  display: flex;
  align-items: center;
}
.circle {
  border-radius: 50%;
  border: 1px solid var(--main-color);
  font-size: 25px;
  text-align: center;
  display: inline-block;
  padding: 14px;
}

.icon {
  height: 20px !important;
  width: 20px !important;
}

.decreased-padding {
  padding-left: 5px;
}
img {
  display: block;
}

.contact-card {
  min-height: 165px;
}

.with-padding {
  padding-bottom: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/CardDropDown.vue